export const MAX_HEIGHT_CUSTOMER_FORM = '350px'